module.exports = __webpack_public_path__ + "static/img/Patient_Encounter_History_Management.e88f762.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Patient_Encounter_History_Management.jpg
// module id = JUOF
// module chunks = 7